import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, firstValueFrom, map, shareReplay, switchMap } from "rxjs";
import { environment } from "../../environments/environment";
import { BaseService } from "./base.service";
import { FilterChip } from "../models/filter-chip";
import { ADGroup } from "../models/ad-group";
import { User } from "../models/user";

@Injectable({ providedIn: 'root' })
export class ADADGroupService extends BaseService {
    private sortProperties : { [key: string]: string } = {
        "key": "Key", "name" : "Name"
    };
    private groupsSubject = new BehaviorSubject<ADGroup[]>([]);
    groups$ = this.groupsSubject.asObservable();

    private sourceUpdatedSubject = new BehaviorSubject<boolean>(false);
    sourceUpdated$ = this.sourceUpdatedSubject.asObservable();

    constructor(private http: HttpClient) {
        super();
    }

    fetchADGroups() {
        this.http.get<ADGroup[]>(environment.apiUrl + 'adgroup/search').subscribe(groups => {
            this.groupsSubject.next(groups);
        });
    }

    filterADGroups(filters: FilterChip[], pageSize: number = 10, pageIndex: number = 0, sortField: string | undefined = undefined, sortDirection: string | undefined = undefined) {
        const keywords = filters.filter(c => c.chip == null).map(v => v.value).join(' ');
        const propertyValues = filters.reduce((v, c) => { if (c.chip != null) v[c.chip] = c.value; return v; }, <{ [key: string]: string }>{});
        const filter = <any>{ keywords, propertyValues };
        if (pageSize) filter['pageSize'] = ''+pageSize
        if (pageIndex) filter['page'] = ''+pageIndex;
        if (sortField) filter['SortSpecifications[0].Property'] = this.sortProperties[sortField];
        if (sortDirection) filter['SortSpecifications[0].Direction'] = sortDirection == "asc" ? "Ascending" : "Descending";

        const filterQuery = this.serialize(filter);
        return this.http.get<ADGroup[]>(environment.apiUrl + 'adgroup/search?' + filterQuery, { observe: 'response' })
            .pipe(
                map(response => {
                    const paging = response.headers.get('Content-Range');
                    const total = parseInt(paging?.split("/")[1] ?? '0');
                    const groups = response.body ?? [];
                    return { total, groups };
                })
            );
        }

    fetchADGroupMembers(samAccountName: string) {
        return firstValueFrom(this.http.get<User[]>(environment.apiUrl + `adgroup/${samAccountName}`));
    }
}